// An abandoned checkout's recovery link: the cart its token held, as the storefront's cart keeps lines.
import { fetchApi } from './client';
import type { PendingLine } from '../commerce/pendingLine';

// Reads the cart an unfinished checkout held; a checkout that became an order, or an unknown token, is refused.
export function recoverCart(token: string): Promise<{ lines: PendingLine[] }> {
  return fetchApi<{ lines: PendingLine[] }>(`/checkouts/${encodeURIComponent(token)}/cart`);
}
